module.exports = __webpack_public_path__ + "static/media/brand-refresh-alert-icon.e5442e8b.svg";